import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-user-confirmation',
	templateUrl: './user-confirmation.component.html',
	styleUrls: ['./user-confirmation.component.scss']
})
export class UserConfirmationComponent implements OnInit {

	@Input() title: string;
	@Input() bodyText: string;

	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit(): void {
	}

}
